import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface ClientApiPortalAccess {
  brand_id: number;
  can_manage_secrets: boolean;
  management_rule: string;
}

export interface ClientApiDeveloperLinks {
  client_uuid: string;
  client_api_base_url: string;
  guide_url: string;
  docs_url: string;
  openapi_url: string;
  expires_in: number;
  expires_at: string;
  scope: string;
}

export interface ClientApiPlaygroundLaunch {
  client_uuid: string;
  client_name: string;
  brand_id: number;
  environment: 'local' | 'backvault' | 'production';
  mode: 'playground';
  launch_url: string;
  expires_in: number;
  expires_at: string;
}

@Injectable({
  providedIn: 'root'
})
export class ClientApiPortalService {
  private readonly brokerBaseUrl = (environment.apiURL || environment.$api_get_url || '').replace(/\/+$/, '')
    + '/api/client-api/portal';

  constructor(private http: HttpClient) {}

  access(): Observable<any> {
    return this.http.get<any>(this.brokerBaseUrl + '/access');
  }

  activity(clientUuid: string, limit = 25): Observable<any> {
    const params = new HttpParams().set('limit', String(limit));
    return this.http.get<any>(
      this.brokerBaseUrl + '/clients/' + encodeURIComponent(clientUuid) + '/activity',
      { params }
    );
  }

  rotateSecret(clientUuid: string): Observable<any> {
    return this.http.post<any>(
      this.brokerBaseUrl + '/clients/' + encodeURIComponent(clientUuid) + '/secrets',
      {}
    );
  }

  developerLinks(clientUuid: string): Observable<{ data: ClientApiDeveloperLinks }> {
    return this.http.post<any>(
      this.brokerBaseUrl + '/clients/' + encodeURIComponent(clientUuid) + '/developer-links',
      {}
    );
  }

  playgroundLaunch(clientUuid: string): Observable<{ data: ClientApiPlaygroundLaunch }> {
    return this.http.post<any>(
      this.brokerBaseUrl + '/clients/' + encodeURIComponent(clientUuid) + '/playground-launch',
      {}
    );
  }
}
